import actions from '../actions';

const {
  ADD_FORM,
  DISABLE_FORM,
  ENABLE_FORM,
  SUBMIT_FORM
} = actions;

/*
 * Reducers
 */

export function forms(state = {}, action) {
  let newState = {...state};
  switch (action.type) {

  case ADD_FORM:
    newState[action.formName] = {
      enabled: true,
      submitted: false
    };
    return newState;

  case DISABLE_FORM:
    newState[action.formName].enabled = false;
    return newState;

  case ENABLE_FORM:
    newState[action.formName].enabled = true;
    return newState;

  case SUBMIT_FORM:
    newState[action.formName].submitted = true;
    newState[action.formName].successMsg = action.successMsg;
    return newState;

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/form.js